@if (isTester()) {
  <button
    type="button"
    class="navigation-header-support__button"
    [disabled]="chatLoading()"
    aria-label="Support"
    (click)="toggleSupportChat()">
    @if (chatLoading()) {
      <span class="support-loading-spinner"></span>
    } @else {
      <span class="navigation-header-support__icon"></span>
    }
  </button>
}
